import React from "react";
import { SearchResultList, SearchSkeletonCard } from "./Search.styles";

const SearchFeedSkeleton = () => (
  <SearchResultList aria-hidden="true">
    {Array.from({ length: 3 }, (_, index) => (
      <SearchSkeletonCard key={index} />
    ))}
  </SearchResultList>
);

export default SearchFeedSkeleton;
